import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "@fontsource-variable/dm-sans/index.css";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);
